import { defineComponent as _defineComponent } from 'vue'
import HoldList from "@/views/hold/HoldList.vue";
import { Affiliate } from "@/services/affiliates/Affiliate";


export default /*#__PURE__*/_defineComponent({
  __name: 'AffiliateHoldList',
  props: {
    affiliate: null
  },
  setup(__props: any) {



return { __sfc: true,HoldList }
}

})